import React from 'react';
import {APIProvider} from '@vis.gl/react-google-maps';
import {getLang} from '../../Localization';
import {getGoogleMapsApiKey} from '../../features/AdvanceDeliveryPlanning/utils/api/googleMaps';
import {calcGPSLocation} from '../../_shared/GWTBridge/invoke/genPage';

export function renderGoogleMapsApiProvider(root, props) {
    const onGoogleMapsApiLoad = () => {
        calcGPSLocation();
    };

    root.render(
        <APIProvider
            language={getLang()}
            apiKey={getGoogleMapsApiKey()}
            onLoad={onGoogleMapsApiLoad}
        />
    );
}
